import {construct, createArrayInstance, createInstance, ModelProperties} from '../utils';

import {Language} from './language';
import {CtPageUrl} from './ct-page-url';
import {CtPageImage} from './ct-page-image';
import {CtPageCategory} from './ct-page-category';

export class CtPage {
    id!: number;

    name!: string;

    tag!: string;

    campaignType?: string;

    campaignNetwork?: string;

    campaignExtraTags?: string;

    categoryId?: number | null;

    targetLanguageId!: number;

    createdAt!: Date;

    updatedAt!: Date;

    category?: CtPageCategory;

    targetLanguage?: Language;

    pageImages?: CtPageImage[];

    pageUrls?: CtPageUrl[];

    outdated?: boolean;

    constructor(page?: ModelProperties<CtPage>) {
        if (page) {
            construct(this, page);
            this.category = createInstance(CtPageCategory, page.category);
            this.targetLanguage = createInstance(Language, page.targetLanguage);
            this.pageUrls = createArrayInstance(CtPageUrl, page.pageUrls);
            this.pageImages = createArrayInstance(CtPageImage, page.pageImages);
        }
    }
}